import { defineStore } from "pinia";
import { basicApi } from "@/services/api";

interface ServerFeatures {
  entraId: boolean;
}

export const useFeaturesStore = defineStore("features", {
  state: () => ({
    error: "" as any,
    data: { entraId: false } as ServerFeatures,
    loaded: false,
  }),
  actions: {
    async fetchAll(force = false) {
      if (!force && this.loaded) return;
      this.error = "";
      await basicApi
        .get<ServerFeatures>(".server/features")
        .then((response) => {
          this.data = response.data;
          this.loaded = true;
        })
        .catch((error) => (this.error = error));
    },
  },
});
